import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'
import axios from 'axios'

const FETCH_ALL_LOMA_USER_REQUEST = 'loma/FETCH_ALL_LOMA_USER_REQUEST'
const FETCH_ALL_LOMA_USER_SUCCESS = 'loma/FETCH_ALL_LOMA_USER_SUCCESS'
const FETCH_ALL_LOMA_USER_FAILURE = 'loma/FETCH_ALL_LOMA_USER_FAILURE'

const FETCH_DEVICE_BY_HERO_REQUEST = 'loma/FETCH_DEVICE_BY_HERO_REQUEST'
const FETCH_DEVICE_BY_HERO_SUCCESS = 'loma/FETCH_DEVICE_BY_HERO_SUCCESS'
const FETCH_DEVICE_BY_HERO_FAILURE = 'loma/FETCH_DEVICE_BY_HERO_FAILURE'

const FETCH_BRANCH_BY_HERO_REQUEST = 'loma/FETCH_BRANCH_BY_HERO_REQUEST'
const FETCH_BRANCH_BY_HERO_SUCCESS = 'loma/FETCH_BRANCH_BY_HERO_SUCCESS'
const FETCH_BRANCH_BY_HERO_FAILURE = 'loma/FETCH_BRANCH_BY_HERO_FAILURE'

const UPDATE_DEVICE_REQUEST = 'loma/UPDATE_DEVICE_REQUEST'
const UPDATE_DEVICE_SUCCESS = 'loma/UPDATE_DEVICE_SUCCESS'
const UPDATE_DEVICE_FAILURE = 'loma/UPDATE_DEVICE_FAILURE'

const UPDATE_BRANCH_REQUEST = 'loma/UPDATE_BRANCH_REQUEST'
const UPDATE_BRANCH_SUCCESS = 'loma/UPDATE_BRANCH_SUCCESS'
const UPDATE_BRANCH_FAILURE = 'loma/UPDATE_BRANCH_FAILURE'

const DELETE_DEVICE_REQUEST = 'loma/DELETE_DEVICE_REQUEST'
const DELETE_DEVICE_SUCCESS = 'loma/DELETE_DEVICE_SUCCESS'
const DELETE_DEVICE_FAILURE = 'loma/DELETE_DEVICE_FAILURE'

const DELETE_BRANCH_REQUEST = 'loma/DELETE_BRANCH_REQUEST'
const DELETE_BRANCH_SUCCESS = 'loma/DELETE_BRANCH_SUCCESS'
const DELETE_BRANCH_FAILURE = 'loma/DELETE_BRANCH_FAILURE'

const RESET_LOMA_DATA = 'RESET_LOMA_DATA'

// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  device: {},
  userList: [],
  branch: {}
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_LOMA_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_LOMA_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userList: action.payload
      }
    case FETCH_ALL_LOMA_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_DEVICE_BY_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_DEVICE_BY_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        device: action.payload
      }
    case FETCH_DEVICE_BY_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_BRANCH_BY_HERO_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRANCH_BY_HERO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        branch: action.payload
      }
    case FETCH_BRANCH_BY_HERO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_DEVICE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_DEVICE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BRANCH_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BRANCH_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BRANCH_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_DEVICE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_DEVICE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BRANCH_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BRANCH_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case RESET_LOMA_DATA:
      return {
        ...state,
        device: null,
        branch: null
      }
    default:
      return state
  }
}

// Action Creators
export const getAllLOMAUsers = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALL_LOMA_USER_REQUEST
      })

      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await axios.get(
        process.env.REACT_APP_API_LOMA_ENDPOINT + `/users/admin/getAllLOMAUser`,
        {
          headers: {
            Authorization: authorizationHeader
          }
        }
      )
      dispatch({
        type: FETCH_ALL_LOMA_USER_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_ALL_LOMA_USER_FAILURE
      })
    }
  }
}
export const fetchDeviceByHeroId = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_DEVICE_BY_HERO_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await axios.get(
        process.env.REACT_APP_API_LOMA_ENDPOINT +
          `/users/admin/device` +
          `/${id}`,
        {
          headers: {
            Authorization: authorizationHeader
          }
        }
      )
      dispatch({
        type: FETCH_DEVICE_BY_HERO_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_DEVICE_BY_HERO_FAILURE
      })
    }
  }
}
export const fetchBranchByHeroId = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BRANCH_BY_HERO_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      const response = await axios.get(
        process.env.REACT_APP_API_LOMA_ENDPOINT +
          `/users/admin/branch` +
          `/${id}`,
        {
          headers: {
            Authorization: authorizationHeader
          }
        }
      )
      dispatch({
        type: FETCH_BRANCH_BY_HERO_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BRANCH_BY_HERO_FAILURE
      })
    }
  }
}

export const updateDevice = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_DEVICE_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await axios.put(
        process.env.REACT_APP_API_LOMA_ENDPOINT +
          `/users/admin/device/editDevice`,
        data,
        {
          headers: {
            Authorization: authorizationHeader
          }
        }
      )
      dispatch({
        type: UPDATE_DEVICE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_DEVICE_FAILURE
      })
    }
  }
}

export const updateBranch = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BRANCH_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await axios.put(
        process.env.REACT_APP_API_LOMA_ENDPOINT +
          `/users/admin/branch/editBranch`,
        data,
        {
          headers: {
            Authorization: authorizationHeader
          }
        }
      )
      dispatch({
        type: UPDATE_BRANCH_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BRANCH_FAILURE
      })
    }
  }
}

export const deleteDevice = (heroId, id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_DEVICE_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await axios.delete(
        process.env.REACT_APP_API_LOMA_ENDPOINT +
          `/users/admin/deleteDevice` +
          `/${heroId}` +
          `/${id}`,
        {
          headers: {
            Authorization: authorizationHeader
          }
        }
      )
      dispatch({
        type: DELETE_DEVICE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_DEVICE_FAILURE
      })
    }
  }
}

export const deleteBranch = (heroId, id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BRANCH_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await axios.delete(
        process.env.REACT_APP_API_LOMA_ENDPOINT +
          `/users/admin/deleteBranch` +
          `/${heroId}` +
          `/${id}`,
        {
          headers: {
            Authorization: authorizationHeader
          }
        }
      )
      dispatch({
        type: DELETE_BRANCH_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BRANCH_FAILURE
      })
    }
  }
}

export const resetLomaData = () => ({
  type: RESET_LOMA_DATA
})
